<template>

    <article class="interview">
        <header>
            <h1>
                <span>Interview<br> of  the </span>
               leaders
            </h1>
        </header>

        <main>

            <figure>
                <div>
                    <img :src="require('../assets/inteview.jpg')" alt="">
                    <figcaption>
                        <span>OUR PURPOSE  </span>
                        <span>AND THE REASONS </span>
                        <span>BEHIND OUR ACTIONS</span>
                    </figcaption>
                </div>
                <div class="legend">
                    <div class="legend-item">
                        <span>Left</span>
                        <strong>Jean-Yves Dagès,</strong>
                        Chairman
                    </div>

                    <div class="legend-item">
                        <span>Right</span>
                        <strong>Thierry Martel,</strong>
                        Chief Executive Officer

                    </div>
                </div>

            </figure>


            <section>

                <h2>How Would You Characterise 2019? What Can We Take Away From The Past Year?

</h2>

                <p>
                    <strong>Jean-Yves Dagès : </strong> 2019 was a complex year economically, socially and environmentally, no doubt reflecting a world in transition with all its accompanying challenges and opportunities.<br>
2019 was characterised by continued low interest rates, occasionally negative rates with the potential to threaten financial balances.
The year was also marked by serious social tensions in France as people expressed concerns on a range of issues from mobility to health and retirement. Significant reforms were introduced by the PACTE (Business Growth and Transformation) law in April and the introduction of the 100% Santé scheme under which the French State will pay the full cost of all optical, auditory and dental care.<br>
Lastly, 2019 reminded us of the importance of environmental issues.<br>
It was another turbulent year in terms of climate, with alternating excessive heatwaves, droughts and floods that resulted in us paying out €250 million in gross claims to our farmer members.
                </p>

            </section>


            <section>

                <h2>So In This Challenging Context, How Did Groupama Perform In Your View? </h2>

                <p>
                    <strong>Thierry Martel : </strong> In this uncertain context, the Groupama Group has been able to report very satisfactory results driven essentially by our business activity in France. Which underlines our financial stability.<br>
Among the key indicators that evidence our good financial health, I would highlight particularly our ongoing progress in profitable organic growth.<br>
Our premium income was up by 1.7% to €14.4 billion at 31 December, while net operating income was 32% higher at €413 million.<br>
All our regional mutuals attracted higher numbers of customers during the year, demonstrating our dynamic performance and ability to compete effectively.<br>
Another point to highlight is the successful launch of our new retirement savings plan, “PER”, with more than 8,000 plans opened by the end of the year, just three months after its introduction!<br>
Group companies pressed ahead with their digital transformations during the year, developing new mobile solutions and forging innovative partnerships.<br>
These very good performances also demonstrated our ability to address social and environmental issues as an integral part of our strategy and actions.<br>
Another very satisfactory factor is our upgrading by Fitch Ratings to A*, still with a positive outlook.
We have now consolidated our financial position to enable us to prepare more effectively for the future.<br> Our solvency coverage ratio of 302% at 31 December reflects that strong position.

                </p>

                <p>
                    <strong>Jean-Yves Dagès : </strong> Another significant development has been the increase in Groupama brand awareness. Recent advertising campaigns built around our mutual values have been very well received by the general public, as has our ongoing sponsorship commitment to the Groupama-FDJ professional cycling team.
                </p>

            </section>
            <blockquote>
                <div class="image jean-yves-dages"></div>
                <p>
                    We are here to help as many people as possible to build their lives with confidence
                    <cite>Jean-Yves Dagès</cite>
                </p>
            </blockquote>
            <section>

                <h2>How Do You See The Outlook For Future Years?</h2>

                <p>
                    <strong>Thierry Martel : </strong> If we’re to succeed in the challenges of the future and perform strongly, we must continue to create value across every aspect of our business, and control our profitability and operating performance in what is a world of constant general, economic and environmental change.
Three areas of our business are particularly impacted by this wider context: mobility, which is directly shaped by environmental issues, health, and savings and retirement.
It remains important for each of us to expand our offerings with increasingly useful and innovative services tailored to the needs of individual customers.

                </p>

                <p>
                    <strong>Jean-Yves Dagès : </strong> To achieve this, we must be technically excellent and control our costs at the same time as valuing people, particularly through training for our elected representatives and employees to enable them to grasp these new challenges and provide increasingly optimal care for our policyholders.
                </p>

                <p>
                    <strong>Thierry Martel : </strong> We must be able to create a customer ecosystem that combines digital and physical networks. The intermediation may be digital, but this ecosystem must be built around - and focused on - individual customers. Digital offerings, connected solutions and cybersecurity are very real sources of new opportunities for Group companies, which in most cases have already positioned themselves in these markets.
                </p>

                <p>
                    <strong>Jean-Yves Dagès : </strong> We face another challenge in the form of the transitions that are directly impacting agriculture, not only in terms of climate change, but also the development of short supply chains, the energy transition, cyber risks, and other issues. So we’re doing everything in our power to meet the industry’s new expectations and risks by paying close attention to its ongoing development. Over the coming years, Groupama intends to remain a partner of excellence for the agricultural industry and its leading insurer.<br>
From that perspective, 2019 also saw substantial input from our Group into the work now being done on risk management in agriculture to improve the resilience of farms.

                </p>


            </section>

            <blockquote class="reverse">
                <div class="image thierry-martel"></div>
                <p>
                    We have now consolidated our financial position to enable us to prepare more effectively for the future.
                    <cite>Thierry Martel</cite>
                </p>
            </blockquote>

            <section>

                <h2>What Is The Group’s Guiding Principle?</h2>

                <p>
                    <strong>Jean-Yves Dagès : </strong> It is encapsulated in our stated corporate purpose. ‘We are here to help as many people as possible to build their lives with confidence’.<br>
To deliver that mission, our business is built on close-knit and responsible mutual aid communities.<br>
We’re more committed than ever to putting our proactive mutual model into action thanks to the commitment of our elected members and employees, and by drawing on all the resources available to us.<br>
It's integral to our DNA. These are the values that have underpinned our identity for more than a century: solidarity, responsibility, local presence and optimism; these timeless values are close to the hearts of the men and women who are Groupama and deliver its services on a daily basis.


                </p>

                <p>
                    <strong>Thierry Martel : </strong> Ours is a purpose for the long haul, which motivates and guides our actions and plans, commits us and guides in reinventing every aspect of our business and continuing to serve our customers and members to the best of our abilities by putting people at the heart of our relationships.
We see our member customers, farmers, local authorities, companies and professionals, pensioners, elected representatives, employees and partners as the reasons behind our actions, because they motivate those actions and give them direction and meaning.<br>
We all have a responsibility to proactively adopt our purpose, and show our determination personally to convey this committed and dynamic mutual model for the future.<br><br>
*On 19 March 2020, Fitch Revises Groupama’s Outlook to Stable, Affirms IFS at ‘A’


                </p>

            </section>

            <nav>
                <router-link to="/etre" class="nav-etre nav-button">Purpose</router-link>
                <div class="nav-line"></div>
                <router-link to="/agir" class="nav-agir nav-button">Actions</router-link>
            </nav>

            <a href="#top" class="scrollTop" @click.prevent="goTop()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 55">
                    <polygon points="95 47.5 47.5 0 0 47.5 7.6 55 47.5 15.1 87.4 55 95 47.5"/>
                </svg>
            </a>

        </main>

    </article>

</template>

<script>
    export default {
        name: "Interview",
        methods: {
            goTop() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        }
    }
</script>

<style scoped lang="scss">

    .interview {
        background: #005848;
        display: flex;
        flex-direction: column;
        align-items: center;

        header {
            background: #006b58;
            align-self: normal;
            width: 100%;
        }

        main {
            max-width: 1130px;
            margin: 75px auto 0;
            padding: 0 15px;

        }

        section {
            padding-left: 90px;
            display: flex;
            flex-direction: column;

            p {
                color: white;
                font-size: 18px;
                line-height: 23px;
                font-weight: 300;

                strong {
                    font-weight: 800;
                }
            }
        }

        h1 {
            display: flex;
            font-weight: 900;
            text-transform: uppercase;
            justify-content: center;
            font-size: 170px;
            line-height: 1;
            color: #004135;
            margin-bottom: 60px;
            margin-top: 60px;

            span {
                text-align: right;
                color: #a1bf38;
                font-weight: 700;
                margin-right: 30px;
                font-size: 40px;
                line-height: 42px;
                transform: translateY(5%);
            }
        }

        h2 {
            color: #a1bf38;
            font-size: 26px;
            line-height: 35px;
            font-weight: 700;
        }

        blockquote {
            margin: 0;
            color: #669b91;
            max-width: 720px;
            margin-left: calc(90px + 90px);
            position: relative;
            margin-bottom: 100px;
            margin-top: 100px;

            .image {
                position: absolute;
                left: -220px;
                width: 150px;
                height: 150px;
                border-radius: 50%;
                display: block;
            }

            p {
                font-weight: 700;
                color: #669b91;
                font-size: 30px;
                line-height: 35px;
                position: relative;

                &::before {
                    content: '';
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-image: url('../assets/quote2.svg');
                    width: 67px;
                    height: 48px;
                    display: block;
                    position: absolute;
                    left: -90px;
                    top: 0;
                }

            }

            cite {
                font-size: 22px;
                font-weight: 500;
                line-height: 45px;
            }

            &.reverse {
                margin-left: auto;
                margin-right: 90px;

                .image {
                    left: auto;
                    right: -220px;
                }

                p {
                    text-align: right;

                    &::before {
                        left: 0;
                        right: -90px;
                        margin-left: auto;
                        transform: scale(-1, 1);
                    }

                }
            }

        }

        figure {
            position: relative;
            margin: 0;
            display: flex;

            img {
                display: block;
                background: #8b8b8b;
                max-width: 100%;
                height: auto;
                width: 100%;
            }

            figcaption {
                font-size: 30px;
                line-height: 32px;
                color: white;
                text-transform: uppercase;
                font-weight: 700;
                display: flex;
                flex-direction: column;
                transform: translateY(calc(-100% / 3));

                span {
                    background-color: #a1bf38;
                    padding: 2px;
                    align-self: flex-start;

                }
            }

            .legend {
                display: flex;
                flex-direction: column;
                margin-left: 30px;

                &-item {
                    display: flex;
                    flex-direction: column;
                    text-transform: uppercase;
                    color: white;
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    span {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        margin-bottom: 6px;
                        font-size: 14px;
                        font-style: italic;
                        text-transform: initial;

                    }

                    strong {
                        display: block;
                    }
                }
            }

        }

        .scrollTop {
            background: #004135;
            border-radius: 50%;
            width: 52px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: auto;
            margin-bottom: 100px;
            margin-top: 100px;

            svg {
                fill: white;
                width: 19px;
                height: 11px;
            }
        }

        .jean-yves-dages {
            background: url(../assets/jy-dages.jpg) center center no-repeat;
            background-size: cover;
        }

        .thierry-martel {
            background: url(../assets/t-martel.jpg) center center no-repeat;
            background-size: cover;
        }

    }

    nav {
        border-top: 1px solid #00352c;
        padding: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 60px;
        margin-bottom: 0;
        padding-bottom: 0;

        .nav {
            &-line {
                width: 1px;
                background: #00352c;
                height: 130px;
                transform: translateY(-15%);
            }

            &-button {
                font-size: 80px;
                font-weight: 900;
                text-transform: uppercase;
                text-decoration: none;
                margin-right: 45px;
                margin-left: 45px;
                opacity: .5;
                transition: .25s ease;
                position: relative;
                line-height: 1.3 !important;

                &:hover {
                    opacity: 1;
                }

                &.nav-etre {
                    color: #a1bf38;

                }

                &.nav-agir {
                    color: #004135;
                }

            }
        }

    }

    @media screen and (max-width: 1480px) {

        .interview {

            blockquote {
                margin: auto !important;

                .image {
                    position: static;
                    margin: auto !important;
                }

                p {
                    text-align: center !important;
                }
            }

            main {
                padding: 0 25px;
            }

            h1 {
                font-size: 100px;

                span {
                    line-height: 1;
                }
            }
        }
    }


    @media screen and (max-width: 1280px) {
        nav {
            .nav {
                &-button {
                    font-size: 100px;
                }
            }
        }
    }

    @media screen and (max-width: 1000px) {


        nav {
            .nav {
                &-button {
                    font-size: 60px;
                }
            }
        }

        .interview {

            section {
                padding-left: 50px;

                p {
                    font-size: 16px;
                }
            }

            blockquote {

                p::before {
                    content: none !important;
                }

                p {
                    font-size: 21px;
                    line-height: 32px;
                }
            }

            h2 {
                font-size: 21px;
                line-height: 30px;
            }

            main {
                max-width: 100%;
                padding: 0 25px;
            }


            h1 {
                flex-direction: column;
                font-size: 50px;
                text-align: center;

                span {
                    font-size: 30px;
                    text-align: center;
                    margin-left: 30px;
                    line-height: 1;

                    br {
                        display: none;
                    }
                }
            }

            figure {
                flex-direction: column;

                .legend {
                    margin-left: 0;
                    flex-direction: row;
                    align-items: flex-start;

                    &-item {
                        font-size: 14px;
                        text-align: center;
                        width: calc(50% - 10px);
                        margin-left: 5px;
                        margin-right: 5px;

                        span {
                            margin: 0 auto 10px;
                        }
                    }

                }

            }
        }

    }


    @media screen and (max-width: 780px) {

        nav .nav-button {
            margin-left: 25px;
            margin-right: 25px;
        }

        nav .nav-line {
            height: 40px;
        }

        .interview {
            header {
                margin-top: 90px;
            }

            blockquote {
                .image {
                    width: 150px;
                    height: 150px;
                }

                cite {
                    font-size: 18px;
                    line-height: 21px;
                    display: block;
                    margin-top: 10px;
                }

                p {
                    font-size: 18px;
                    line-height: 21px;
                }
            }
        }
    }

    @media screen and (max-width: 480px) {

        nav {
            flex-direction: column;
        }

        .interview {
            section {
                padding-left: 0;
            }
            header {
                margin-top: 50px;
            }

            h2 {
                font-size: 20px;
            }
        }

        .interview figure figcaption {
            display: block;
            font-size: 20px;
            line-height: 22px;
        }

        nav .nav-button {
            font-size: 40px;
        }

        nav .nav-line {
            display: none;
        }
    }

</style>
